// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"633ecdd7","977":"71d053ed"}[chunkId] + ".chunk.js";
};